

/// <reference path="StockNote.ts" />

// Generated class DeliveryOrder_ManagedObject

class DeliveryOrder_ManagedObject extends StockNote
{

    // Property: legalEntityName
    set legalEntityName(value:string) {
        this.setValueForKey(value, 'legalEntityName');
    }
    get legalEntityName():string {
        return this.valueForKey('legalEntityName');
    }
    set legalEntityNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'legalEntityName');
    }
    get legalEntityNamePrimitiveValue():string {
        return this.primitiveValueForKey('legalEntityName');
    }

    // Property: legalEntityReference
    set legalEntityReference(value:string) {
        this.setValueForKey(value, 'legalEntityReference');
    }
    get legalEntityReference():string {
        return this.valueForKey('legalEntityReference');
    }
    set legalEntityReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'legalEntityReference');
    }
    get legalEntityReferencePrimitiveValue():string {
        return this.primitiveValueForKey('legalEntityReference');
    }
}
